module.exports = __webpack_public_path__ + "img/client_registry_ast.79ca7441.png";